// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"2499e552","224":"2df66430","393":"6d6b3cb2","453":"952d81e6","555":"0712b8dd","963":"afdc5c2d"}[chunkId] + ".chunk.js";
};